module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-image02-1440x700.9332b43f.jpg";